module.exports = __webpack_public_path__ + "img/E0A6.b96b190e.svg";